<script lang="ts">
  import { Swiper } from 'swiper'
  import { Autoplay, Grid, Pagination } from 'swiper/modules'

  import { onMount } from 'svelte'

  import { resolve } from '$app/paths'

  import type { Pathname } from '$app/types'
  import Article from '~/components/business/article.svelte'

  let shelfMounted = $state(false)

  const shelfList = [
    {
      image: '/webp/blog-article-s-2.webp',
      title: 'Controle de estoque: Software ou Planilha?',
      description:
        'Iremos mostrar o porquê planilhas são bloqueadores de eficiência em processos das sua empresas.',
      icon: 'vaadin:chart-3d',
      href: resolve(
        '/(blog)/blog/articles/controle-de-estoque-software-ou-planilha-compare'
      ) as Pathname,
    },
    // {
    //   title: 'LGPD em Aplicativos',
    //   description:
    //     'Até quando os dados podem ser acessíveis em aplicativos, iremos comentar como a LGPD funciona para aplicativos.',
    //   icon: 'solar:server-square-cloud-bold-duotone',
    //   href: resolve('/(blog)/blog/articles/lgpd-em-aplicativos', {}),
    // },
    // {
    //   title: 'Software Sob-medida Vs Software de Prateleira',
    //   description:
    //     'Será que as empresas estão prontas para Software Sob-medida ou irão deixar de ganhar 60% de eficiência com o Software de prateleira.',
    //   icon: 'solar:cart-2-line-duotone',
    //   href: resolve('/(blog)/blog/articles/sob-medida-vs-prateleira', {}),
    // },
    {
      image: '/webp/blog-article-s-3.webp',
      title: 'Quanto custa desenvolver um Software?',
      description:
        'Veja quanto um software deve custar para ser desenvolvido sem problemas, sem erros, sem falhas. Do início ao mercado de maneira mais prática possível.',
      icon: 'fluent:flash-28-filled',
      href: resolve('/(blog)/blog/articles/quanto-custa-desenvolver-software') as Pathname,
    },
  ]

  onMount(() => {
    shelfMounted = true
  })

  $effect.pre(() => {
    if (shelfMounted)
      new Swiper('.swiper-articles', {
        modules: [Pagination, Autoplay, Grid],
        spaceBetween: 24,

        pagination: {
          enabled: true,
          el: '.swiper-pagination',
          bulletClass: 'swiper-pagination-bullet',
          bulletActiveClass: 'swiper-pagination-bullet-activate !bg-brand !opacity-100',
        },

        breakpoints: {
          0: { slidesPerView: 1, loop: false, grid: { fill: 'row' } },
          780: { slidesPerView: 2, grid: { fill: 'row', rows: 1 } },
          1024: { slidesPerView: 4, slidesPerGroup: 4, loop: true },
        },
      })
  })
</script>

<style lang="postcss">
  .swiper-articles {
    @apply relative z-10 mx-auto block overflow-hidden p-0;
  }

  .article-list :global(.article) {
    min-height: 180px;
  }
</style>

<section class="section | mt-[80px] lg:mb-[128px] lg:mt-0">
  <div class="mx-auto w-full px-4 lg:w-[80%] lg:px-0">
    <h2 class="title | mb-8 text-center text-4xl font-medium md:text-5xl">Artigos recentes</h2>

    <!-- Slider main container -->
    {#if shelfMounted}
      <div class="swiper-articles article-list">
        <!-- Additional required wrapper -->
        <ul class="swiper-wrapper pb-[56px]">
          <!-- Slides -->
          {#each shelfList as { image, title, description, href }}
            <li class="swiper-slide">
              <article class="article-item | w-full grow rounded-lg border border-gray-200">
                <div class="m-0">
                  <Article {image} {title} {description} {href} />
                </div>
              </article>
            </li>
          {/each}
        </ul>
        <!-- If we need pagination -->
        <div class="swiper-pagination"></div>

        <!-- If we need navigation buttons -->
        <div class="swiper-button-prev z-100"></div>
        <div class="swiper-button-next z-100"></div>
      </div>
    {:else}
      <ul class="flex flex-row gap-6 overflow-hidden">
        <!-- Slides -->
        {#each shelfList as { image, title, description, href }}
          <li class="w-full lg:w-1/4">
            <article class="article-item | w-full grow rounded-lg border border-gray-200">
              <div class="m-0">
                <Article {image} {title} {description} {href} />
              </div>
            </article>
          </li>
        {/each}
      </ul>
    {/if}
  </div>
</section>
